export default __webpack_public_path__ + "08cd07d9771440f163898d77d37941fe.png";